<template>
  <section class="s-strip s-strip--theme-grey s-videos-slick">
    <div class="page-container">
      <SlickCarousel
        ref="slick"
        :key="'key-' + slickKey"
        class="s-videos-slick__slick"
        :options="slickOptions"
        @afterchange="onAfterChange">
        <div
          v-for="item in records"
          :key="item.id"
          class="s-videos-slick__slide item">
          <VideoBlock :video-id="item.videoId" :image="item.image" />
        </div>
      </SlickCarousel>
    </div>
  </section>
</template>

<script>
import SlickCarousel from '../components/common/SlickCarousel.vue'
import VideoBlock from '../components/VideoBlock.vue'
import * as lib from './../../lib/lib'

export default {
  components: { SlickCarousel, VideoBlock },
  data() {
    return {
      records: [],
      slickKey: 0,
      slickOptions: {
        draggable: false,
        infinite: true,
        autoplay: false,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    }
  },

  mounted() {
    const { records } = lib.getData('videosData')

    this.records = records
  },

  methods: {
    onAfterChange() {
      document.dispatchEvent(new Event('pause-all-videos'))
    },
  },
}
</script>
